export const FAILED = "Failed";
export const LOCKEDOUT = "LockedOut";
export const REQUIRES_TWO_FACTOR = "RequiresTwoFactor";
